// import React from "react";

//  import Header from "./Header";
//  import Footer from "./Footer";
//  import GlobalState, { Context } from "../context/GlobalState";
//  import "../App.css";
//  import { AppLoader } from "src/components/LoaderSpinner";
//  import Notifcation from "src/components/Notifcation";
//  import { UserStoryState } from "../context/UserStoryState";

//  export default function Wrapper({ children }) {
//      const store = GlobalState();

//      return (
//          <Context.Provider value={store}>
//              <UserStoryState>
//                  <div className="">
//                      <Header />
//                      <Notifcation />
//                      <main className="body-container">
//                          {store.loading ? (
//                              <AppLoader size={30} />
//                          ) : (
//                              <>{children}</>
//                          )}
//                      </main>
//                      <Footer />
//                  </div>
//              </UserStoryState>
//          </Context.Provider>
//      );

//  }

import React from "react";
import { useLocation } from "react-router-dom"; // Import useLocation from react-router-dom
import Header from "./Header";
import Footer from "./Footer";
import GlobalState, { Context } from "../context/GlobalState";
import "../App.css";
import { AppLoader } from "src/components/LoaderSpinner";
import Notifcation from "src/components/Notifcation";
import { UserStoryState } from "../context/UserStoryState";

export default function Wrapper({ children }) {
  const store = GlobalState();
  const location = useLocation(); // Get the current location

  // Define paths where the header should NOT be rendered
  const noHeaderPaths = [
    "/ascendo",
    "/course-runs",
    "/checkout",
    "/payment",
    "/thank-you",
    "/payment/",
  ]; // Add paths here to hide the header

  // Check if the current path matches any of the paths where the header should be hidden
  const shouldHideHeader = noHeaderPaths.includes(location.pathname);

  return (
    <Context.Provider value={store}>
      <UserStoryState>
        <div className="">
          {/* Conditionally render the Header based on the current path */}
          {!shouldHideHeader && <Header />}
          <Notifcation />
          <main className="body-container">
            {store.loading ? <AppLoader size={30} /> : <>{children}</>}
          </main>
          <Footer />
        </div>
      </UserStoryState>
    </Context.Provider>
  );
}
